// src/components/forms/mapping-editor/AuthorInfoEditor.tsx (Create this file)
import React, { useCallback } from 'react';
import { AuthorInfoFields } from '../../../../interfaces/dynamicForms/PdfMapping';
import FormInput from '../formBuilder/FormInput';

interface AuthorInfoEditorProps {
  fields: AuthorInfoFields | undefined; // Mapping data for this section
  onChange: (newFields: AuthorInfoFields) => void; // Callback to update parent state
}

const AuthorInfoEditor: React.FC<AuthorInfoEditorProps> = ({ fields, onChange }) => {

  // Use useCallback to memoize the handler function
  const handleChange = useCallback((fieldName: keyof AuthorInfoFields, value: string) => {
    // Create the updated fields object
    const updatedFields: AuthorInfoFields = {
      // Spread existing fields or default to empty object if undefined
      ...(fields ?? { SCFullName: '', SCID: '', SupervisorFullName: '', ProgramManagerFullName: '' }),
      // Update the specific field that changed
      [fieldName]: value || undefined, // Store empty string as undefined or empty string? Let's use undefined if empty. Or keep as string? Let's keep as string for simplicity.
    };
    // Call the parent's update function
    onChange(updatedFields);
  }, [fields, onChange]); // Dependencies: re-create if fields object or onChange function changes

  return (
    <div className="p-4 border rounded bg-white shadow-sm mb-6">
      <h3 className="text-lg font-semibold mb-3 text-gray-700">Author Info PDF Fields</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormInput
          label="PDF Field for SC Full Name"
          id="scFullNamePdfField"
          value={fields?.SCFullName || ''} // Use current value or empty string
          onChange={(e) => handleChange('SCFullName', e.target.value)}
          placeholder="e.g., AuthorFullNameField"
        />
        <FormInput
          label="PDF Field for SCID"
          id="scidPdfField"
          value={fields?.SCID || ''} // Use current value or empty string
          onChange={(e) => handleChange('SCID', e.target.value)}
          placeholder="e.g., SCIDField"
        />
        <FormInput
          label="PDF Field for Supervisor Full Name"
          id="supervisorFullNamePdfField"
          value={fields?.SupervisorFullName || ''} // Use current value or empty string
          onChange={(e) => handleChange('SupervisorFullName', e.target.value)}
          placeholder="e.g., SupervisorFullNameField"
        />
        <FormInput
          label="PDF Field for Program Manager Full Name"
          id="programManagerFullNamePdfField"
          value={fields?.ProgramManagerFullName || ''} // Use current value or empty string
          onChange={(e) => handleChange('ProgramManagerFullName', e.target.value)}
          placeholder="e.g., ProgramManagerFullNameField"
        />
        <FormInput
          label="PDF Field for Agency Name"
          id="organizationName"
          value={fields?.OrganizationName || ''} // Use current value or empty string
          onChange={(e) => handleChange('OrganizationName', e.target.value)}
          placeholder="e.g., Organization Name"
        />
        <FormInput
          label="PDF Field for Contact Type"
          id="taskType"
          value={fields?.SupervisorFullName || ''} // Use current value or empty string
          onChange={(e) => handleChange('TaskType', e.target.value)}
          placeholder="e.g., Monthly"
        />
      </div>
      <p className="text-xs text-gray-500 mt-2">
        Specify the exact names of the PDF form fields where the logged-in user's full name and SCID should be placed.
      </p>
    </div>
  );
};

export default AuthorInfoEditor;